// 課程表單查詢整頁（form-class-form-list＝legacy form/classFormList.jsp）。
// 批次 41（#39 修復 3/3，Gitea issue #39）：complexBody 整頁置換（批次 13/15/24 先例）。
//
// ── 為什麼要 complexBody（本批的裁決與理由）────────────────────────────────
// 泛用列表模板的查詢區由 LegacyContractFields 以**契約欄位**驅動，而契約以 `name` 為
// 比對 key（FUNCTIONAL-CONTRACT.md D-2／legacy-fields.ts 規則 1）：
//   - `formStatus` radio×3（全部/進行中/已完成，classFormList.jsp:481-483）同 name 同
//     variantKey → 去重多數決只畫 **1 顆**（R2 缺元素 label[27]/[28]/[29]×3）；
//   - `showMyForm` checkbox（:488）**沒有 name** → 抽出器整個丟掉（缺元素 input[31]＋
//     #text[32]「(只顯示自己待填的表單)」）。
// 要畫齊這些就得動 generated 紅線（legacy-fields.generated）或整頁自寫——裁決（使用者
// 2026-09-30）：**complexBody 化**（自寫查詢區 radio 群/checkbox/按鈕群/說明 ul＋沿用
// 表格殼 DataTableShell/Table；比照批次 15/24 前例；不動 generated 紅線）。
//
// ── 對應 legacy（行號＝form/classFormList.jsp 基準 ePortfolio_work；JS＝js-my/formList.js）──
//   - 查詢區（:411-511，form#queryForm）：契約欄位（annualId…enableStatus，順序照 raw DOM）
//     ＋表單進行狀態 radio×3（:481-483，`全部 value="" checked`／`進行中 false`／`已完成 true`，
//     doQuery :303 送 `formStatus`）＋自己待填的表單 checkbox（:488，doQuery :304 送
//     `showMyForm`，文字「(只顯示自己待填的表單)」）＋課程期間清除鈕（:464，
//     resetDateTimePicker 圓形鈕＋fa-eraser 圖示；雛形以「清除」文字鈕呈現＝ArrangeTrainBody
//     先例，legacy 是按鈕內空文字→成 1 筆文字差）。
//   - 右欄說明（:514-518）：ul li「變更表單歸屬者，請用第一排勾選，一次只能選1張單改，
//     因為成員可能不同，不能混合一次改。」（R2 缺元素 ul@root[2]）。
//   - 按鈕列（:493-509，查詢 form 內）：查詢/列印（ACCESS）、啟用/停用/刪除（DELETE）、
//     變更表單歸屬者/變更目前填寫者/變更為未完成（UPDATE）、a 通知填寫（manualInform-ACCESS）。
//     legacy 全是 input[type=button]＋`<a href="javascript:void(0);">`；React 按鈕一律
//     `<button>`＝GNL-004 同族核准差（形態不同；R8 canonical 落地自動配對清零）。列印鈕
//     （:495 showPrintForms）與變更歸屬者鈕（:503 formList.showChangeClassFormStudent）本批新畫。
//     「變更目前填寫者」（:504）**刻意不在按鈕列重畫**：modal（dialogModal/mentorForm）已由
//     LegacyContractModals 的 trigger 開啟（同一 modal、D-3 自報）；重畫一顆會變成
//     同文字雙按鈕＋重複 modal 觸發——維持 R2 裁決「GNL-004 同族 AD 已判」（input[39]
//     對 root trigger 反查）。
//   - 表格（:521-546，formTable）：15 欄（表頭序列 legacy-table-headers），第一欄＝勾選欄
//     （formCheckBox，列 checkbox＋表頭 form-select-all :525 全選）；沿用 DataTableShell＋
//     Table（選取桶語意同 selectionBuckets ['form']）。
//   - 列印 form（:592-596，printForm POST target=_blank＋hidden ids）：本批鏡像（ids 值
//     由勾選列組成，預設空字串）；列印動作＝驗證後站內導航（B19-2/D19-2 先例，printForms
//     頁為 0 契約參數頁不消費參數）。csrf hidden 照 Q2 裁決不畫（歸 (e)）。
//   - 變更表單歸屬 modal（changeFormStudentModal.jsp：標題「變更表單歸屬」、新歸屬者下拉、
//     是否要也變更流程人員下拉、關閉/存檔；showChangeClassFormStudent :466-489 未選擇表單!/
//     只能選擇1張表單!；changeClassFormStudent :491-513 未選擇新歸屬者!／未選擇是否要變更
//     流程人員!／是否確定要變更新歸屬者？）。modal 內容不進結構比對（關閉態不渲染）。
//   - 批量流程（doUpdateFormStatus :210／doDeleteForm :161／reopenFormFlow :364／
//     doInformFiller :309）＝FormListBulkToolbar 同文複製（文字逐字；本體改用本機勾選狀態）。
//     表頭 form-select-all 取代原型「全選」鈕（該鈕是 form-select-all 的雛形版，legacy 沒有）。
//
// ── 誠實標註（KNOWN-NOT-DONE）────────────────────────────────────────────
//   - formStatus/showMyForm 查詢為伺服器端過濾（getFormListAjax）——雛形 filters 直送
//     MockDataSource（matchesFilters 對種子列沒有的鍵＝全等比對；種子列不帶鍵＝不被過濾），
//     過濾語意【雛形值待實機校準】（批次 23 同款揭露）。
//   - 變更歸屬者存檔（changeClassFormStudentAjax）以 dataSource.update(studentId) 呈現，
//     resp.desc 成功文案為 server 回應【雛形值待實機校準】→ t('state.saveSuccess')。
//   - 列印 POST 不真送（target=_blank 新分頁由站內導航鏡像）；列印頁為 0 契約參數頁（B4-2）。
//   - 新歸屬者下拉 legacy 為班級學生 AJAX——雛形以學員池平列【雛形值待實機校準】。
//   - 日期為文字輸入（legacy datepicker/readonly＋resetDateTimePicker 清除）。
//
// 【證據等級】§7 第 3 級（原始碼，行號親讀 2026-09-30）。

import { useState, type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { panelHeadingLevelFor } from '@/app/panel-heading-levels';
import { Button } from '@/components/base/Button';
import { Select } from '@/components/base/Select';
import { Table, type TableColumn } from '@/components/base/Table';
import { ContentPanel, ModalFrame, useDialogs } from '@/components/layouts';
import { DataTableShell } from '@/components/layouts/DataTableShell';
import { LegacyContractModals } from '@/components/layouts/LegacyContractModals';
import { t } from '@/messages/zh-TW';
import {
  columnsFor,
  DEFAULT_PAGE_SIZE,
  initialValues,
  legacyContractFieldsFor,
  legacyTableSequenceFor,
  type Row,
  resolveLegacyMessage,
  resolveLegacyMessageForAction,
  toPayload,
  useDataSource,
  useList,
} from '@/mocks';
import { TRAINING_STUDENT_OPTIONS } from '@/mocks/resource-rules';
import { LegacyContractFields } from '../templates/LegacyContractFields';
import { legacyAlertFallback } from '../templates/page-behaviors';
import { rowUiKey, TemplateError, toUiKey } from '../templates/shared';

/** 變更表單歸屬 modal 的「是否要也變更流程人員」選項（changeFormStudentModal.jsp:19-23）。 */
const CHANGE_FLOW_OPTIONS: readonly { value: string; label: string }[] = [
  { value: '', label: '請選擇' },
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

export function ClassFormListBody({ pageId }: { pageId: string }): ReactElement {
  const dataSource = useDataSource();
  const dialogs = useDialogs();
  const navigate = useNavigate();

  // ------------------------------------------------------------------
  // 查詢區（classFormList.jsp:411-511）。契約欄位照畫；formStatus radio 群與
  // showMyForm checkbox 本體自畫（complexBody 緣起見檔頭）。
  // ------------------------------------------------------------------
  const contractFields = legacyContractFieldsFor(pageId) ?? [];
  // 渲染排除：formStatus（去重只留 1 顆＝本批缺元素根源，改由 radio 群自畫）、
  // ids（legacy 屬 printForm :594-595，不在查詢 form）。
  const renderFields = contractFields.filter(
    (field) => field.name !== 'formStatus' && field.name !== 'ids',
  );
  // 課程期間清除鈕（:464 resetDateTimePicker）在 legacy 位於課程期間起訖與啟用狀態之間——
  // 契約欄位序列以此切兩段插入（round-5 同標籤 LCS 保序，位置錯了會變成缺元素+多元素）。
  const enableStatusIndex = renderFields.findIndex((field) => field.name === 'enableStatus');
  const dateFields = renderFields.slice(0, enableStatusIndex === -1 ? renderFields.length : enableStatusIndex);
  const tailFields = enableStatusIndex === -1 ? [] : renderFields.slice(enableStatusIndex);
  const [draftFieldValues, setDraftFieldValues] = useState<Record<string, string>>(() =>
    initialValues(contractFields, pageId),
  );
  const [showMyForm, setShowMyForm] = useState(false);
  const formStatus = draftFieldValues['formStatus'] ?? '';

  // ------------------------------------------------------------------
  // 清單（doQuery :295-330；formStatus :303、showMyForm :304 入查詢）。
  // ------------------------------------------------------------------
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [keyword, setKeyword] = useState('');
  const [filters, setFilters] = useState<Record<string, string>>({});
  const { data, loading, error, reload } = useList(pageId, { page, pageSize, keyword, filters });
  const rows = data?.rows ?? [];

  function applySearch() {
    // toPayload 對不可驅動欄位（ids hidden）一律帶出 key（C5-h）；formStatus 已在
    // draftFieldValues（radio 群 onChange 寫入）。
    setFilters({
      ...toPayload(draftFieldValues, contractFields, pageId),
      showMyForm: showMyForm ? 'true' : '',
    });
    setPage(1);
  }

  function setFieldValue(name: string, next: string) {
    setDraftFieldValues((current) => ({ ...current, [name]: next }));
  }

  // ------------------------------------------------------------------
  // 勾選（formCheckBox 第一欄＋表頭 form-select-all :525/:377-380）。
  // legacy table.$('input[name="formCheckBox"]:checked', {page:'all'}) 跨頁收集——
  // 以 Map<id, row> 累積（流程文字需要列的 done/enabled）。
  // ------------------------------------------------------------------
  const [checked, setChecked] = useState<Map<string, Row>>(new Map());
  const toggleRow = (row: Row) => {
    const id = String(row.id ?? '');
    setChecked((previous) => {
      const next = new Map(previous);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.set(id, row);
      }
      return next;
    });
  };
  const selectedIds = () => [...checked.keys()];
  const clearSelection = () => {
    setChecked(new Map());
  };
  const allSelected = rows.length > 0 && rows.every((row) => checked.has(String(row.id ?? '')));
  const toggleAll = () => {
    setChecked((previous) => {
      const next = new Map(previous);
      if (allSelected) {
        for (const row of rows) next.delete(String(row.id ?? ''));
      } else {
        for (const row of rows) next.set(String(row.id ?? ''), row);
      }
      return next;
    });
  };
  const doneOf = (id: string) => String(checked.get(id)?.done ?? '') === '1';
  const enabledOf = (id: string) => String(checked.get(id)?.enabled ?? '') === '1';

  // ------------------------------------------------------------------
  // 批量流程（js-my/formList.js；文字與 FormListBulkToolbar 逐字相同，已由測試鎖）。
  // ------------------------------------------------------------------
  const statusFlow = (word: '啟用' | '停用') => {
    void (async () => {
      const ids = selectedIds();
      if (ids.length === 0) {
        await dialogs.alert('未選擇表單!');
        return;
      }
      // formList.js:245/:250 逐字（複驗 F2）：已啟用再啟用／已停用再停用 = 操作錯誤。
      const target = word === '啟用' ? '1' : '0';
      const wrongState = ids.filter((id) => enabledOf(id) === (target === '1'));
      if (wrongState.length > 0) {
        await dialogs.alert(
          word === '啟用' ? '操作錯誤!您選到已經是啟用狀態的表單!' : '操作錯誤!您選到已經是停用狀態的表單!',
        );
        return;
      }
      const doneQty = ids.filter((id) => doneOf(id)).length;
      const confirmed = await dialogs.confirm(
        `${doneQty > 0 ? `${word}[已完成]的表單數量: ${String(doneQty)}\n\n` : ''}${word}表單總數量: ${String(ids.length)}\n\n是否確定要${word}表單?`,
      );
      if (!confirmed) {
        return;
      }
      try {
        await dialogs.processing.wrap(
          Promise.all(
            ids.map((id) => dataSource.update(pageId, id, { enabled: word === '啟用' ? '1' : '0' })),
          ),
        );
        clearSelection();
        reload();
        await dialogs.info(t('state.saveSuccess'));
      } catch (cause: unknown) {
        await dialogs.alert(legacyAlertFallback(cause));
      }
    })();
  };

  const deleteFlow = () => {
    void (async () => {
      const ids = selectedIds();
      if (ids.length === 0) {
        await dialogs.alert('未選擇表單!');
        return;
      }
      const doneQty = ids.filter((id) => doneOf(id)).length;
      const confirmed = await dialogs.confirm(
        `${doneQty > 0 ? `刪除[已完成]的表單數量: ${String(doneQty)}\n\n` : ''}刪除表單總數量: ${String(ids.length)}\n\n是否確定要刪除表單?`,
      );
      if (!confirmed) {
        return;
      }
      try {
        await dialogs.processing.wrap(Promise.all(ids.map((id) => dataSource.remove(pageId, id))));
        clearSelection();
        reload();
        await dialogs.info(t('state.saveSuccess'));
      } catch (cause: unknown) {
        await dialogs.alert(legacyAlertFallback(cause));
      }
    })();
  };

  const reopenFlow = () => {
    void (async () => {
      const ids = selectedIds();
      if (ids.some((id) => doneOf(id) === false)) {
        await dialogs.alert('錯誤! 已完成的表單才能改為未完成!');
        return;
      }
      if (ids.length === 0) {
        await dialogs.alert('錯誤! 未選擇表單!');
        return;
      }
      const confirmed = await dialogs.confirm('是否確定要變更表單為未完成?');
      if (!confirmed) {
        return;
      }
      try {
        await dialogs.processing.wrap(
          Promise.all(ids.map((id) => dataSource.update(pageId, id, { done: '0' }))),
        );
        clearSelection();
        reload();
        await dialogs.info(t('state.saveSuccess'));
      } catch (cause: unknown) {
        await dialogs.alert(legacyAlertFallback(cause));
      }
    })();
  };

  const informFlow = () => {
    void (async () => {
      const ids = selectedIds();
      if (ids.some((id) => doneOf(id) === true)) {
        await dialogs.alert('已完成的表單不需要發送通知，請重新選擇!');
        return;
      }
      if (ids.length === 0) {
        await dialogs.alert('未選擇表單!');
        return;
      }
      // formList.js:332 逐字（複驗 F1）。
      const confirmed = await dialogs.confirm('是否確定要發送填寫通知?');
      if (!confirmed) {
        return;
      }
      // legacy POST form/informFillFormAjax（js-my/formList.js:309-330）；雛形不送真通知（B1-3）。
      await dialogs.info(t('state.saveSuccess'));
    })();
  };

  // ------------------------------------------------------------------
  // 列印（showPrintForms formList.js:125-140）＋ printForm 鏡像（:592-596）。
  // ------------------------------------------------------------------
  const [printIds, setPrintIds] = useState('');
  const showPrintForms = () => {
    void (async () => {
      const ids = selectedIds();
      if (ids.length === 0) {
        await dialogs.alert('未選擇表單!');
        return;
      }
      // legacy：填 #ids → printForm POST target=_blank 送出（新分頁列印）；
      // 雛形以站內導航鏡像（B19-2/D19-2 先例；printForms 頁為 0 契約參數頁不消費參數）。
      setPrintIds(JSON.stringify(ids));
      navigate('/form/prompt/printForms');
    })();
  };

  // ------------------------------------------------------------------
  // 變更表單歸屬者（formList.js:466-489 showChangeClassFormStudent → modal；
  // :491-513 changeClassFormStudent 存檔）。
  // ------------------------------------------------------------------
  const [changeStudentOpen, setChangeStudentOpen] = useState(false);
  const [newOwnerStuId, setNewOwnerStuId] = useState('');
  const [isChangeFlow, setIsChangeFlow] = useState('');
  const showChangeClassFormStudent = () => {
    void (async () => {
      const ids = selectedIds();
      if (ids.length === 0) {
        await dialogs.alert('未選擇表單!');
        return;
      }
      if (ids.length > 1) {
        await dialogs.alert('只能選擇1張表單!');
        return;
      }
      setNewOwnerStuId('');
      setIsChangeFlow('');
      setChangeStudentOpen(true);
    })();
  };
  const changeClassFormStudent = () => {
    void (async () => {
      if (newOwnerStuId === '') {
        await dialogs.alert('未選擇新歸屬者!');
        return;
      }
      if (isChangeFlow === '') {
        await dialogs.alert('未選擇是否要變更流程人員!');
        return;
      }
      const confirmed = await dialogs.confirm('是否確定要變更新歸屬者？');
      if (!confirmed) {
        return;
      }
      try {
        await dialogs.processing.wrap(
          Promise.all(
            selectedIds().map((id) =>
              dataSource.update(pageId, id, { studentId: newOwnerStuId, isChangeFlow }),
            ),
          ),
        );
        setChangeStudentOpen(false);
        clearSelection();
        reload();
        // resp.desc 成功文案為 server 回應【雛形值待實機校準】→ 通用存檔完成。
        await dialogs.info(t('state.saveSuccess'));
      } catch (cause: unknown) {
        await dialogs.alert(legacyAlertFallback(cause));
      }
    })();
  };

  // ------------------------------------------------------------------
  // 表格（:521-546；表頭序列 legacy-table-headers，第一欄＝勾選欄＋表頭全選）。
  // ------------------------------------------------------------------
  const columns = columnsFor(pageId);
  const sequence = legacyTableSequenceFor(pageId);
  const checkColumnKey = sequence?.find((column) => column.actions)?.key ?? 'actions';
  const tableColumns: readonly TableColumn[] =
    sequence === undefined
      ? columns.map((column) => ({ key: column.key, header: column.label }))
      : sequence.map((column) => ({
          key: column.key,
          header:
            column.key === checkColumnKey ? (
              // 表頭 form-select-all（:525）：原型版「全選」鈕由這顆取代（legacy 沒有全選鈕）。
              <input
                id="form-select-all"
                type="checkbox"
                data-ui-id={`${pageId}-form-select-all`}
                checked={allSelected}
                onChange={toggleAll}
                className="size-4 accent-brand"
              />
            ) : (
              column.header
            ),
        }));
  // 本頁無 legacy-tables 形狀資料（linkKeys 空）——儲存格全為純文字。

  const legacyEmptyMessage = resolveLegacyMessage(pageId, 'empty');
  async function exportRows() {
    try {
      await dataSource.list(pageId, { page, pageSize, keyword, filters, export: true });
    } catch {
      await dialogs.alert(
        resolveLegacyMessageForAction(pageId, 'failure', 'export')?.text ?? t('error.generic'),
      );
      return;
    }
    await dialogs.info(t('export.notice'));
  }

  const resultShell = (
    <DataTableShell
      uiId={`${pageId}-result`}
      page={page}
      pageSize={pageSize}
      total={data?.total ?? 0}
      keyword={keyword}
      loading={loading}
      onPageChange={setPage}
      onPageSizeChange={(next) => {
        setPageSize(next);
        setPage(1);
      }}
      onKeywordChange={(next) => {
        setKeyword(next);
        setPage(1);
        reload();
      }}
      {...(legacyEmptyMessage === null ? {} : { emptyText: legacyEmptyMessage.text })}
      exportEffect={`list:${pageId}#export`}
      onExport={() => {
        void exportRows();
      }}
    >
      <Table
        uiId={`${pageId}-result-table`}
        columns={tableColumns}
        rows={rows}
        rowKey={rowUiKey}
        emptyText=""
        renderCell={(row, columnKey) => {
          if (columnKey === checkColumnKey) {
            // formCheckBox 勾選欄（classFormList.jsp:70、表頭全選 :525）。
            const id = String(row.id ?? '');
            return (
              <input
                type="checkbox"
                data-ui-id={`${pageId}-row-${toUiKey(id)}-check-form`}
                checked={checked.has(id)}
                onChange={() => {
                  toggleRow(row);
                }}
                className="size-4 accent-brand"
              />
            );
          }
          const raw = row[columnKey];
          return raw === undefined || raw === null ? '' : String(raw);
        }}
      />
    </DataTableShell>
  );

  // ------------------------------------------------------------------
  // 整頁（legacy 順序：查詢 form＋右欄 ul → 表格 → modal 群 → printForm）。
  // ------------------------------------------------------------------
  return (
    <div data-ui-id={pageId}>
      <LegacyContractModals pageId={pageId} />
      <ContentPanel
        uiId={`${pageId}-panel`}
        title="課程表單查詢"
        headingLevel={panelHeadingLevelFor(pageId)}
      >
        {error !== null ? (
          <TemplateError uiId={`${pageId}-error`} error={error} onRetry={reload} pageId={pageId} />
        ) : null}
        <div className="grid gap-4 md:grid-cols-12">
          <div className="md:col-span-7">
            {/* form#queryForm（:411）；Enter 送出＝原生 form submit（SearchPanel 同款）。 */}
            <form
              data-ui-id={`${pageId}-search`}
              noValidate
              className="flex flex-col gap-3"
              onSubmit={(event) => {
                event.preventDefault();
                applySearch();
                reload();
              }}
            >
              <LegacyContractFields
                pageId={pageId}
                fields={dateFields}
                values={draftFieldValues}
                onChange={setFieldValue}
                disabled={loading}
              />
              {/* 課程期間清除鈕（:464）：legacy 是圓形鈕內 fa-eraser 圖示（文字節點為空）；
                  雛形不畫圖示（svg 子樹會成多元素）＝空文字按鈕完全鏡像（normalize 後兩側皆
                  button[type=button] 無子節點）；aria-label 僅供讀報讀器（aria 不在比對 allowlist）。 */}
              <button
                type="button"
                data-ui-id={`${pageId}-query-dates-reset`}
                aria-label="清除課程期間"
                className="inline-block size-8 rounded-full border border-border text-ink hover:bg-surface-subtle disabled:cursor-not-allowed disabled:opacity-[.65]"
                disabled={loading}
                onClick={() => {
                  setFieldValue('classStartDate', '');
                  setFieldValue('classEndDate', '');
                }}
              />
              <LegacyContractFields
                pageId={pageId}
                fields={tailFields}
                values={draftFieldValues}
                onChange={setFieldValue}
                disabled={loading}
              />
              {/* 表單進行狀態 radio 群（:480-483）；doQuery :303 送 formStatus。 */}
              <div className="flex flex-wrap items-center gap-2" data-ui-id={`${pageId}-search-form-status-group`}>
                <label className="mb-[5px] inline-block font-bold text-ink">表單進行狀態：</label>
                <label className="inline-flex items-center gap-1 text-sm text-ink">
                  <input
                    type="radio"
                    name="formStatus"
                    value=""
                    checked={formStatus === ''}
                    onChange={() => {
                      setFieldValue('formStatus', '');
                    }}
                    className="size-4 accent-brand"
                  />
                  {' 全部'}
                </label>
                <label className="inline-flex items-center gap-1 text-sm text-ink">
                  <input
                    type="radio"
                    name="formStatus"
                    value="false"
                    checked={formStatus === 'false'}
                    onChange={() => {
                      setFieldValue('formStatus', 'false');
                    }}
                    className="size-4 accent-brand"
                  />
                  {' 進行中'}
                </label>
                <label className="inline-flex items-center gap-1 text-sm text-ink">
                  <input
                    type="radio"
                    name="formStatus"
                    value="true"
                    checked={formStatus === 'true'}
                    onChange={() => {
                      setFieldValue('formStatus', 'true');
                    }}
                    className="size-4 accent-brand"
                  />
                  {' 已完成'}
                </label>
              </div>
              {/* 自己待填的表單（:486-491）；doQuery :304 送 showMyForm。 */}
              <div className="flex flex-wrap items-center gap-2" data-ui-id={`${pageId}-search-show-my-form-group`}>
                <label className="mb-[5px] inline-block font-bold text-ink">自己待填的表單：</label>
                <input
                  id="showMyForm"
                  type="checkbox"
                  data-ui-id={`${pageId}-search-show-my-form`}
                  checked={showMyForm}
                  onChange={(event) => {
                    setShowMyForm(event.target.checked);
                  }}
                  className="size-4 accent-brand"
                />
                {'(只顯示自己待填的表單)'}
              </div>
              {/* 按鈕列（:493-509）：查詢/列印/啟用/停用/刪除/變更表單歸屬者/變更為未完成＋a 通知填寫。
                  「變更目前填寫者」由 LegacyContractModals trigger 開啟同一 modal（檔頭說明）。 */}
              <div className="flex flex-wrap items-center gap-2" data-ui-id={`${pageId}-search-actions`}>
                <Button
                  uiId={`${pageId}-search-submit`}
                  variant="primary"
                  size="sm"
                  type="submit"
                  disabled={loading}
                  dataEffect={`list:${pageId}`}
                >
                  查詢
                </Button>
                <Button
                  uiId={`${pageId}-form-print`}
                  variant="default"
                  size="sm"
                  type="button"
                  onClick={showPrintForms}
                >
                  列印
                </Button>
                <Button
                  uiId={`${pageId}-form-bulk-enable`}
                  variant="default"
                  size="sm"
                  type="button"
                  dataEffect={`update:${pageId}`}
                  onClick={() => {
                    statusFlow('啟用');
                  }}
                >
                  啟用
                </Button>
                <Button
                  uiId={`${pageId}-form-bulk-disable`}
                  variant="default"
                  size="sm"
                  type="button"
                  dataEffect={`update:${pageId}`}
                  onClick={() => {
                    statusFlow('停用');
                  }}
                >
                  停用
                </Button>
                <Button
                  uiId={`${pageId}-form-bulk-delete`}
                  variant="danger"
                  size="sm"
                  type="button"
                  dataEffect={`remove:${pageId}`}
                  onClick={deleteFlow}
                >
                  刪除
                </Button>
                <Button
                  uiId={`${pageId}-form-change-student`}
                  variant="default"
                  size="sm"
                  type="button"
                  dataModalTrigger={`${pageId}-change-student-dialog`}
                  onClick={showChangeClassFormStudent}
                >
                  變更表單歸屬者
                </Button>
                <Button
                  uiId={`${pageId}-form-bulk-reopen`}
                  variant="default"
                  size="sm"
                  type="button"
                  dataEffect={`update:${pageId}`}
                  onClick={reopenFlow}
                >
                  變更為未完成
                </Button>
                {/* legacy 是 <a href="javascript:void(0);" class="btn btn-danger">（:509）——
                    元素形態照實畫成 <a>。href 照 CrudListPage 的 a.showEdit 前例**不給**：
                    React 會把 javascript: URL 換成 throw Error 佔位字串（安全限制），照抄反而多一筆
                    href 屬性差；無 href 的屬性差（legacy 有/react 無）與被改寫的屬性差等量，
                    取前例形（role/tabIndex 鍵盤等效，aria/role/tabindex 都不在比對 allowlist）。 */}
                {/* biome-ignore lint/a11y/useSemanticElements: 換成 <button> 會讓標籤名與原系統不同（原系統是 <a>），直接多一筆 structure 差異 */}
                {/* biome-ignore lint/a11y/useValidAnchor: 原系統的 <a> 是 javascript:void(0)（onclick 驅動）；React 對 javascript: URL 會改寫成 throw Error，兩者都非零和，取無 href 前例。鍵盤等效操作已由 tabIndex + onKeyDown 提供。 */}
                <a
                  data-ui-id={`${pageId}-form-bulk-inform`}
                  className="cursor-pointer text-sm text-[#cc3333] hover:underline"
                  role="button"
                  tabIndex={0}
                  onClick={(event) => {
                    event.preventDefault();
                    informFlow();
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      event.preventDefault();
                      informFlow();
                    }
                  }}
                >
                  通知填寫
                </a>
              </div>
            </form>
          </div>
          {/* 右欄說明（:514-518）——R2 缺元素 ul@root[2]。 */}
          <div className="md:col-span-5">
            <ul className="list-disc pl-5 text-sm text-ink">
              <li>變更表單歸屬者，請用第一排勾選，一次只能選1張單改，因為成員可能不同，不能混合一次改。</li>
            </ul>
          </div>
        </div>
        {resultShell}
      </ContentPanel>
      {/* 變更表單歸屬 modal（changeFormStudentModal.jsp；關閉態不渲染＝不進結構比對）。 */}
      <ModalFrame
        uiId={`${pageId}-change-student-dialog`}
        open={changeStudentOpen}
        title="變更表單歸屬"
        size="lg"
        onClose={() => {
          setChangeStudentOpen(false);
        }}
        footer={
          <>
            <Button
              uiId={`${pageId}-change-student-close`}
              variant="default"
              size="sm"
              type="button"
              onClick={() => {
                setChangeStudentOpen(false);
              }}
            >
              關閉
            </Button>
            <Button
              uiId={`${pageId}-change-student-save`}
              variant="primary"
              size="sm"
              type="button"
              dataEffect={`update:${pageId}`}
              onClick={changeClassFormStudent}
            >
              存檔
            </Button>
          </>
        }
      >
        <div className="flex flex-col gap-3">
          <input type="hidden" name="formId" value={selectedIds()[0] ?? ''} onChange={() => undefined} />
          <div className="flex items-center gap-2">
            <label className="w-28 shrink-0 text-right text-sm">新歸屬者：</label>
            <div className="w-64">
              <Select
                uiId={`${pageId}-change-student-new-owner`}
                name="newOwnerStuId"
                value={newOwnerStuId}
                onChange={setNewOwnerStuId}
                options={TRAINING_STUDENT_OPTIONS}
              />
            </div>
          </div>
          <div className="flex items-start gap-2">
            <label className="w-56 shrink-0 text-right text-sm">
              是否要也變更流程人員：
              <br />
              流程與舊的人相同才會換
            </label>
            <div className="w-64">
              <Select
                uiId={`${pageId}-change-student-is-change-flow`}
                name="isChangeFlow"
                value={isChangeFlow}
                onChange={setIsChangeFlow}
                options={CHANGE_FLOW_OPTIONS}
              />
            </div>
          </div>
        </div>
      </ModalFrame>
      {/* printForm 鏡像（:592-596）：POST target=_blank＋hidden ids（csrf 照 Q2 裁決不畫）。 */}
      <form
        data-ui-id={`${pageId}-print-form`}
        action="/form/prompt/printForms"
        method="POST"
        target="_blank"
        noValidate
        onSubmit={(event) => {
          event.preventDefault();
        }}
      >
        <input
          type="hidden"
          name="ids"
          value={printIds}
          onChange={() => undefined}
          data-ui-id={`${pageId}-print-ids`}
        />
      </form>
    </div>
  );
}
